module.exports = __webpack_public_path__ + "img/deactive.6e9583c2.svg";